import moment from 'moment'

export default class DateHelper {
  static getMomentFromDateStr(dateStr) {
    return moment(dateStr)
  }

  static formatDate(momentObject, styleStr) {
    if (momentObject && momentObject.format && typeof momentObject.format === 'function') {
      return momentObject.format(styleStr)
    }
    return moment(momentObject).format(styleStr)
  }

  /**
   * 返回 YYYY-MM-DD样式的日期
   * @param momentObject
   * @returns {string}
   */
  static getFormatDate(momentObject) {
    return DateHelper.formatDate(momentObject, 'YYYY-MM-DD')
  }

  static getCurrentFormatDate(styleStr) {
    if (styleStr) {
      return DateHelper.formatDate(moment(), styleStr)
    }
    return DateHelper.getFormatDate(moment())
  }

  static getMoment(date) {
    if (date) {
      return moment(date)
    }
    return undefined
  }

  static getDateMoments(date1, date2) {
    return [
      moment(date1),
      moment(date2)
    ]
  }

  static getTimeHourMinte(data) {
    let hour = new Date(data).getHours()
    let minute = new Date(data).getMinutes()
    if (Number(hour) < 10) {
      hour = '0' + hour
    }
    if (Number(minute) < 10) {
      minute = '0' + minute
    }
    return hour + ':' + minute
  }

  static getTimeMinute(date) {
    if (date) {
      return moment(date, 'HH:mm')
    }
    return undefined
  }

  static getDaysInMonth(date) {
    return moment(date).daysInMonth()
  }

  static diffYears(startTime, endTime) {
    return moment(endTime).diff(moment(startTime), 'years')
  }

  static diffMonths(startTime, endTime) {
    return moment(endTime).diff(moment(startTime), 'months')
  }

  static diffDays(startTime, endTime) {
    return moment(endTime).diff(moment(startTime), 'days')
  }

  static diffMinutes(startTime, endTime) {
    return moment(endTime).diff(moment(startTime), 'minutes')
  }

  static diffSeconds(startTime, endTime) {
    return moment(endTime).diff(moment(startTime), 'seconds')
  }
}